import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './sliderLearn.scss'

function SliderLearn({ elements }) {
  const settings = {
    lazyLoad: true,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    speed: 1500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1210,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }
  return (
    <div className="f-slider-learn">
      <Slider {...settings} className="f-slider-learn__container">
        {elements.map(element => {
          return element
        })}
      </Slider>
    </div>
  )
}

export default SliderLearn
